/* eslint-disable react/no-danger */
import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { purgeStoredState } from 'redux-persist';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Popup from 'react-popup';
import { asyncSessionStorage } from 'redux-persist/storages';
import { trackLink } from '../../lib/analytics-helper';
import * as shape from '../constants/PropTypesShapes';

// Components
import TooltipMobile from '../components/TooltipMobile';
import CollapseSegment from '../components/common/CollapseSegment';

// Helper
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import l10n from '../../lib/reactPPl10nHelper';
import contentHelper from '../../lib/contentHelper';
import { parserContactUs } from '../../lib/dataParser';
import { PayPayCredit } from '../constants/UtilVariables';

// Call Us label data
const callUs = {
  header: i18n.message('smarthelp/callUs.callUs.header'),
  phone: i18n.message('smarthelp/callUs.callUs.phone'),
  splInstruction: i18n.message('smarthelp/callUs.callUs.splInstruction'),
  serviceHours: i18n.message('smarthelp/callUs.callUs.serviceHours'),
  instruction: i18n.message('smarthelp/callUs.callUs.instruction'),
  passcode: i18n.message('smarthelp/callUs.callUs.passcode'),
  change: i18n.message('smarthelp/callUs.callUs.change'),
  tooltip: i18n.message('smarthelp/callUs.callUs.tooltip'),
  ok: i18n.message('smarthelp/callUs.callUs.ok'),
  accountFlag: i18n.message('smarthelp/callUs.callUs.accountManage.flag'),
  accountMTS: i18n.message('smarthelp/callUs.callUs.accountManage.MTS'),
  generalFlag: i18n.message('smarthelp/callUs.callUs.generalFlag'),
};

// Constants
const device = Page.getDeviceType();
const country = Page.getCountry();
const PPC = {
  logoutUS: Page.isLogoutUS(),
  header: l10n.getContent('smarthelp/callUs.callUsPanel.PPC.header'),
  phone: PayPayCredit.number,
  topicChecker: l10n.getContent('smarthelp/callUs.callUsPanel.PPC.topic'),
  hours: Page.getHTMLElement({ message: PayPayCredit.hours, useHTML: true }),
};

class CallUs extends Component {
  static renderPhoneNumber(number, index) {
    if (number) {
      const key = `${index}|${number}`;
      return (
        <li key={key} className="phone-number-item">
          {CallUs.clickToCall(number)}
        </li>
      );
    }
    return null;
  }

  // Allow user to call by clicking phone number
  static clickToCall(phone) {
    return (
      <a href={`tel:${phone}`} className="click-to-call">
        {phone}
      </a>
    );
  }

  // Get service hour item
  static getServiceItem(items) {
    return !_isEmpty(items) ?
      Object.entries(items).map(item => (
        CallUs.serviceHourItem({ key: item[0], value: item[1] })
      )) : null;
  }

  // Show each available content in the customer service list
  static serviceHourItem(options) {
    return !_isEmpty(options) && options.key && options.value ?
      (
        <li
          className="service-hour-item"
          key={options.key}
          dangerouslySetInnerHTML={{ __html: options.value }}
        />
      ) : null;
  }

  // render request a call
  static renderRac(key) {
    if (key === 'phone' && Page.isLoggedIn()) {
      return (
        <span
          id="node-rac" ref={() => {
              // eslint-disable-next-line no-undef
            nodeRac.render('node-rac');
          }}
        />
      );
    }
    return null;
  }

  // Render Phone Number section
  static renderPhonePanel(key, numbers, header) {
    return Array.isArray(numbers) && numbers.length > 0 && numbers[0] ?
      (
        <div className={`${key}-container`} >
          <h2 className={`${key}-header`}>{header}</h2>
          {CallUs.renderRac(key)}
          <ul className={`${key}-number`}>
            {numbers.map((number, index) => CallUs.renderPhoneNumber(number, index))}
          </ul>
        </div>
      ) : null;
  }

  // Render Instruction in the bottom of Call Us page
  static renderInstruction() {
    return (
      <div className="instruction-container">
        {CallUs.showIPInstruction()}
        <div className="content">{callUs.instruction}</div>
      </div>
    );
  }

  static showMobilePopup(tooltipData, ok) {
    return Popup.create({
      content: <TooltipMobile tooltip={tooltipData} ok={ok} />,
      position: { x: 0, y: 0 },
    });
  }

  static showTooltip(tooltipData) {
    if (device === 'desktop') {
      return <span className="vx_icon vx_icon-small vx_icon-tooltip-small" data-tip={tooltipData} />;
    }
    return (<button
      className="vx_icon vx_icon-small vx_icon-tooltip-small"
      onClick={() => CallUs.showMobilePopup(tooltipData, callUs.ok)}
      role="link"
    />);
  }

  // Display IP relay verbiage only for US
  static showIPInstruction() {
    if (_isString(country) && country.toLowerCase() === 'us') {
      return (
        <div className="content">{callUs.splInstruction}</div>
      );
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      isToolTipTouched: false,
    };
  }

  componentDidMount() {
    Page.scrollToTop();
  }

  // This component will not re-render during state `isToolTipTouched` changes.
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.isToolTipTouched === true) {
      return false;
    }
    return true;
  }

  // Get Service Hour list
  getServiceHourList() {
    return (
      <ul className="service-hour-list">
        {CallUs.getServiceItem(this.parserContactInfo().customerHour)}
      </ul>
    );
  }

  trackTooltip() {
    return () => {
      if (this.state.isToolTipTouched === false) {
        trackLink({
          id: 'callUsPage',
          link: 'smarthelp-tooltip',
        });
      }

      this.setState({
        isToolTipTouched: true,
      });
    };
  }

  showcontent() {
    purgeStoredState({ storage: asyncSessionStorage }).then(() => {
    });

    return (
      <div className="callUs-container">
        {this.renderPayPalInfo()}
        {CallUs.renderInstruction()}
      </div>
    );
  }

  showPasscode() {
    if (this.parserContactInfo().webPin) {
      return (<div className="webpin">
        <div className="passcode">
          {callUs.passcode}
          {CallUs.showTooltip(callUs.tooltip)}
          <ReactTooltip
            className="tooltip_passcode" afterHide={this.trackTooltip()}
            multiline place="top" effect="solid"
          />
          <div className="passcode-tool-tip">
            <Popup />
          </div>
        </div>
        <div className="font-pin">{this.parserContactInfo().webPin}</div>
      </div>);
    }
    return null;
  }

  // Parser Call Us page data
  parserContactInfo() {
    let contactInfo = {};
    if (this.props.callus.contactInfo && !_isEmpty(this.props.callus.contactInfo)) {
      // Parser Call us Info data
      contactInfo = parserContactUs(this.props.callus.contactInfo);
    }
    return contactInfo;
  }

  // User reach to the topic tree leaf node and get Select result
  isTopicLeafNode() {
    return !_isEmpty(this.props.selectResult.topicTreeSelectResult);
  }

  // The first layer 1 topic is `PayPal Credit`
  isTopicPPCredit() {
    return !_isEmpty(this.props.topicSelect.topics) && this.props.topicSelect.topics.layer1 === PPC.topicChecker;
  }
  /**
   * isDisplayPPCredit: Render PayPayCredit phone nuber and customer hour
   * PPCredit display logic:
   * Display for US logout account with two condtion:
   *    1). Not react to end of topic tree leaf node
   *    2). Topic tree Layer 1 topic is PayPay Credit ( topic Id : paypal_credit_l1 )
   */
  isDisplayPPCredit() {
    return PPC.logoutUS || this.props.PPCEnable;
  }

  // Collapse only display when both PP and PPC are exist
  isDisplayCollapse() {
    return !this.isTopicLeafNode() && this.isDisplayPPCredit();
  }

  renderPayPalCredit() {
    return (
      <div className="paypal-credit-container">
        {CallUs.renderPhonePanel(
          'ppc',
          [PPC.phone],
          PPC.header,
        )}
        {this.renderCustomerHourPanel({ header: callUs.serviceHours,
          body: (
            <div className="ppc-hours">
              { PPC.hours }
            </div>
          ) })}
      </div>
    );
  }

  /**
   * renderPayPalInfo
   * 1. User has PayPal Credit account and clicks Call us without an intent - sees both PP and PPC number/hours on Call us page
   * 2. User does not have PayPal Credit account and clicks Call us without an intent - sees only PP number/hours on Call Us page
   * 3. User selects an intent and then clicks Call Us - show either the PP number or PP Credit number (or whatever is hardcoded for that topic, for PP Working Capital, etc.),
   *  regardless of whether they
   */
  renderPayPalInfo() {
    if (!this.isTopicLeafNode()) {
      return (
        <div>
          {this.renderContactUsInfo()}
          {this.renderPPServiceHour()}
          {this.isDisplayPPCredit() && this.renderPayPalCredit()}
        </div>
      );
    } else if (this.isTopicPPCredit()) {
      return (
        <div>
          {this.renderPayPalCredit()}
        </div>
      );
    }
    return (
      <div>
        {this.renderContactUsInfo()}
        {this.renderPPServiceHour()}
      </div>
    );
  }

  // Render call us number and sevice hour
  renderContactUsInfo() {
    return (
      <div className="contact-us-info-container">
        {CallUs.renderPhonePanel(
          'mts',
          [this.parserContactInfo().generalMTS || this.parserContactInfo().mtsPhone],
          callUs.accountMTS,
        )}
        {CallUs.renderPhonePanel(
          'am',
          [this.parserContactInfo().amPhone],
          contentHelper(callUs.accountFlag, { flageName: this.parserContactInfo().amFlag || '' }),
        )}
        {CallUs.renderPhonePanel(
          'phone',
          this.parserContactInfo().phoneNumber,
          callUs.phone,
        )}
        {CallUs.renderPhonePanel(
          'general',
          [this.parserContactInfo().generalPhoneNumber],
          callUs.generalFlag,
        )}
        {this.showPasscode()}
        <div className="special-inst" dangerouslySetInnerHTML={{ __html: this.parserContactInfo().specialInstruction }} />
      </div>
    );
  }

  // Render the PP Customer Service hour
  renderPPServiceHour() {
    return (
      <div className="service-hour-container">
        {this.renderCustomerHourPanel({ header: callUs.serviceHours, body: this.getServiceHourList() })}
      </div>
    );
  }

  // Render Customer hour with Collapse style
  renderCustomerHourPanel({ header, body }) {
    const ServiceHour = props => (
      <div className="service-hours-container">
        <h3 className="service-hours-header">{props.header}</h3>
        {props.children}
      </div>
    );
    const HourTag = this.isDisplayCollapse() ? CollapseSegment : ServiceHour;
    return (
      <HourTag header={header} >
        {body}
      </HourTag>
    );
  }

  render() {
    if (this.props.display) {
      return (
        <div className="callUs-Panel">
          <h1 className="header">{callUs.header}</h1>
          {this.showcontent()}
        </div>);
    }
    return null;
  }
}

function mapStateToProps(state) {
  return {
    callus: state.callUs.callUsResult,
    display: state.callUs.display,
    PPCEnable: state.PPCredit.ppcEnable, // For login PayPalCredit account
    topicSelect: state.topicSelect, // For checking Layer 1 topic name, which whether equal to `PayPal Credit` or not
    selectResult: state.selectResult,
  };
}

CallUs.propTypes = {
  callus: PropTypes.shape(shape.CALL_US),
  display: PropTypes.bool.isRequired,
  PPCEnable: PropTypes.bool.isRequired,
  topicSelect: PropTypes.shape(shape.TOPICSELECT).isRequired,
  selectResult: PropTypes.shape(shape.TOPIC_TREE_SELECT_RESULT).isRequired,
};

CallUs.defaultProps = {
  display: false,
  callus: undefined,
  loading: false,
  error: false,
};

export default connect(mapStateToProps)(CallUs);
